/**
 * לקוח ה-API של הגשת בקשה להצעת מחיר — TASKS 4.3–4.4, 5.2.
 * ⛔ ⛔ הבקשה עצמה לא מכילה שום שדה מחיר — ראו `server/src/routes/public/quotes.ts`.
 */
import type { CartItem } from '../cart/CartContext.js';
import { parseErrorBody } from './apiError.js';

export { isPublicApiError } from './apiError.js';

export interface SubmitQuoteRequestInput {
  fullName: string;
  phone: string;
  email: string;
  company?: string;
  notes?: string;
  whatsappConsent: boolean;
  termsConsent: boolean;
  captchaToken: string;
  items: CartItem[];
}

export interface SubmitQuoteRequestResponse {
  quoteNumber: string;
  phoneDisplay: string;
  whatsappBusinessPhone: string;
}

export async function submitQuoteRequest(
  input: SubmitQuoteRequestInput,
): Promise<SubmitQuoteRequestResponse> {
  const res = await fetch('/api/quotes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      fullName: input.fullName,
      phone: input.phone,
      email: input.email,
      company: input.company,
      notes: input.notes,
      whatsappConsent: input.whatsappConsent,
      termsConsent: input.termsConsent,
      captchaToken: input.captchaToken,
      items: input.items.map((item) => ({
        productId: item.productId,
        variantId: item.variantId,
        measurements: item.measurements,
      })),
    }),
  });
  if (!res.ok) throw await parseErrorBody(res);
  return (await res.json()) as SubmitQuoteRequestResponse;
}
